<template>
<transition enter-active-class="ease-out duration-300 transition" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="fixed z-20 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-full pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6">
        <div class="block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="$emit('close')" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            <span class="sr-only">Close</span>
            <!-- Heroicon name: outline/x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="sm:flex sm:items-start">
          <div class="sm:text-left">
            <h3 class="mr-10 text-lg leading-6 font-semibold text-gray-800 flex items-center space-x-3" id="modal-title">
              <span>Our DBS Check Requirements</span>
            </h3>
            
            <div class="mt-3 space-y-2 text-sm text-gray-700">
              <p>
                In order to pass our DBS Check, we will:
              </p>
              <ul class="space-y-3">
                <li
                  v-for="item of [
                    'Need to see an <strong class=font-semibold>Enhanced</strong> DBS certificate. A Standard or Basic will not be accepted.',
                    'Expect that the certificate be dated within the last three years.',
                    'Check that details on the certificate match an official form of government ID, e.g. passport or driving licence.',
                    'Check that details on the certificate match your Tutor Index profile.',
                    'Ensure there are no recorded convictions, cautions, reprimands, or warnings.',
                    'Check that you are not on any Barred lists, and there is no other recorded information that might be relevant.',
                  ]"
                  :key="item"
                  class="flex items-center space-x-2"
                >
                  <CheckCircleIcon class="w-5 h-5 text-green-500 flex-shrink-0 self-start" /> 
                  <span v-html="item"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import { InformationCircleIcon } from '@vue-hero-icons/outline'
import { ShieldCheckIcon, CheckCircleIcon } from '@vue-hero-icons/solid'
import dayjs from 'dayjs'

export default {
  components: {
    InformationCircleIcon,
    ShieldCheckIcon,
    CheckCircleIcon,
  },
  props: {
    open: Boolean,
  },
  data() {
    return {
      dayjs,
    }
  }
}
</script>

<style>

</style>